import { ColorModel } from '../models';
import { createSelectedHook } from '../utils';
import { selectBestMatchingColor } from '../utils/selectBestMatchingColor';

import { useAppSelector } from '~/redux/hooks';
import {
  selectRestorableColor,
  selectSelectedColor,
  selectUsableColors,
} from '~/redux/slices/color';

const useColorsData = (): ColorModel[] => useAppSelector(selectUsableColors);

export const useSelectedColor = createSelectedHook({
  selector: selectSelectedColor,
  restorableSelector: selectRestorableColor,
  apiQueryHook: useColorsData,
  selectRestorableValue: ({
    apiHookResponse,
    restorableValue,
    selectedValue,
  }) =>
    selectedValue ??
    apiHookResponse.find(
      (color) => color.productId === restorableValue?.productId
    ),

  shouldReturnDefault: ({ selectedValue, apiHookResponse }) =>
    !selectedValue ||
    !apiHookResponse.find(
      (color) => color.productId === selectedValue?.productId
    ),
  selectDefaultValue: ({ apiHookResponse, selectedValue }) =>
    selectBestMatchingColor(selectedValue, apiHookResponse), // This finds the best match OR the default
});
